export default (obj) => typeof Object(obj)[Symbol.iterator] === 'function';
